$(document).ready(function () {
    if (location.hash !== null && location.hash !== "") {
        console.log(location.hash)
        $(location.hash + ".collapse").collapse("show");
        $("#login" + ".collapse").collapse("hide");
    }
});

$('#EmailAddress').blur(function () {
    $.ajax({

        url: '/api/doesMailExists',
        type: 'POST',
        data: {
            'email': $('#EmailAddress').val()
        },
        dataType: 'json',
        success: function (data) {
            if (data === 0) {
                $("#registerForm").collapse("show");
                $("#mailexists").hide();
            }
            if (data === 1) {
                $("#registerForm").collapse("hide");
                $("#mailexists").show();

            }
        }
    })
});


$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})